<script setup lang="ts">
import type {
  IUserSelection,
  IViewData,
} from "@/stories/form/DatePicker/shared";
import ViewHeader from "@/stories/form/DatePicker/ViewHeader.vue";
import { computed } from "vue";

const CURRENT_YEAR = new Date().getFullYear();

const CURRENT_MONTH = new Date().getMonth();

interface Props {
  view: IViewData;
  selection: IUserSelection | null;
}

const props = defineProps<Props>();

defineEmits(["setView"]);

const months = computed(() => {
  const formatter = new Intl.DateTimeFormat(navigator.language || "da", {
    month: "short",
  });

  const months = Array.from({ length: 12 }, (_, i) =>
    formatter.format(new Date(2023, i, 1)),
  );

  return months;
});

const isSelectedMonth = (index: any) => {
  return (
    props.view.year === props.selection?.year &&
    props.selection?.month === index
  );
};

const isCurrentMonth = (index: any) => {
  return props.view.year === CURRENT_YEAR && index === CURRENT_MONTH;
};
</script>

<template>
  <div>
    <ViewHeader
      @prev-click="$emit('setView', { year: props.view.year - 1 })"
      @next-click="$emit('setView', { year: props.view.year + 1 })"
      @title-click="$emit('setView', { type: 'years' })"
    >
      {{ props.view.year }}
    </ViewHeader>
    <div class="grid grid-cols-3 gap-2">
      <button
        type="button"
        v-for="(month, index) of months"
        :key="index"
        :class="[
          'w-full py-3 text-center rounded-lg text-neutral1000 text-lg font-semibold focusVisible test-month-selector focus-visible-strong',
          isSelectedMonth(index)
            ? 'bg-darkOcean100 border border-darkOcean500 focus-visible:border-transparent'
            : '',
          isCurrentMonth(index) && !isSelectedMonth(index)
            ? 'bg-neutral50 text-darkOcean500 font-bold'
            : '',
        ]"
        @click="$emit('setView', { month: index, type: 'days' })"
      >
        {{ month }}
      </button>
    </div>
  </div>
</template>
